import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    grower: {
        transition: 'all 0.1s linear',
        '&:hover': {
            transform: 'scale(1.1)',
        },
    },
    confetti: {
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
    },
}));
